import React, { useRef, useState } from "react";
import { logResponse } from "../utils/logger";
import { fetchRequestResetPassword } from "../api";
import SubmitButton from "../components/SubmitButton";

const Forget = () => {
  const formRef = useRef();
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setMessage("");
    setIsError(false);

    const formData = new FormData(formRef.current);
    const email = formData.get("email")?.trim();

    if (!email || !isValidEmail(email)) {
      setMessage("有効なメールアドレスを入力してください。");
      setIsError(true);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await fetchRequestResetPassword({ email });
      logResponse("req:", email);
      logResponse("res:", res);

      if (res.detail) {
        setMessage(res.detail);
        setIsError(true);
      } else if ("message" in res) {
        if (!res.message || res.message.trim() === "") {
          setMessage("ご入力頂いたメールアドレスは登録されていません。");
          setIsError(true);
        } else {
          setMessage("メールを送信しました。メールに記載の認証用URLをクリックしてください。");
          setIsError(false);
        }
      } else {
        setMessage("予期せぬ応答です。");
        setIsError(true);
      }
    } catch (err) {
      console.error("API呼び出しエラー:", err);
      setMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
      setIsError(true);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section form-section section-block">
      <form className="login-form" ref={formRef} noValidate>
        <div className="form-group">
          <label htmlFor="email">ご登録のメールアドレス</label>
          <div className="overlap-group-wrapper">
            <div className="overlap-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                required
                autoComplete="email"
                aria-describedby="email-error"
              />
            </div>
          </div>
        </div>

        {message && (
          <div className="form-group">
            <p style={{ color: isError ? "red" : "green", fontWeight: "bold" }}>
              {message}
            </p>
          </div>
        )}

        <div className="btn-green">
          <SubmitButton
            type="button"
            onClick={handleSubmit}
            isSubmitting={isSubmitting}
            label="パスワードリセット"
            className="btn-green"
            wrap={false}
          />
        </div>

        <p className="comment tc">
          上記メールアドレス宛てに
          <br />
          メールが届きますのでご確認ください。
        </p>
      </form>
    </section>
  );
};

export default Forget;
